import SetupLayout from "components/layout/SetupLayout";
import AddMembers from "components/layout/SetupLayout/AddMembers";
import AddBank from "components/onboarding/AddBank";
import CompanyAddress from "components/onboarding/CompanyAddress";
import FinancialDocuments from "components/onboarding/FinancialDocuments";
// import IdentityVerification from "pages/Onboarding/IdentityVerification";
import { Navigate, Route, Routes } from "react-router-dom";

const OnboardingRoutes = () => {
  return (
    <SetupLayout>
      <Routes>
        {/* <Route path="/setup/identity" element={<IdentityVerification />} /> */}
        <Route path="/setup/company" element={<CompanyAddress />} />
        <Route path="/setup/invite" element={<AddMembers />} />
        <Route path="/setup/bank" element={<AddBank />} />
        <Route path="/setup/documents" element={<FinancialDocuments />} />
        {/* <Route path="/setup/agree" element={<SignDocuments />} /> */}
        <Route path="*" element={<Navigate to="/setup/company" />} />
      </Routes>
    </SetupLayout>
  );
};

export default OnboardingRoutes;
